import en_notifications from "../../api/resources/lang/en/notifications.php";

export default {
    en: {
        notifications: en_notifications
    }
};